import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Recaptcha from "react-google-invisible-recaptcha";
import Cookies from "universal-cookie";
import $ from "jquery";

import { getParameter } from "../util/util";
import { encrypt } from "../api/generic";
import { GlobalContext } from "../context/GlobalContext";
import ProfileUpdate from "./ProfileUpdate";
import './Modal.css';
import {
  checkUser,
  validateOTP,
  reSendSMS,
  profileEnquiry
} from "../api/api";

class Login extends Component {
  static contextType = GlobalContext;
  componentDidMount() {
    if (this.props.userType) {
      this.setState({
        userType: this.props.userType,
      });
    }
    if (this.props.defaultNumber) {
      this.setState({
        mobileNumber: this.props.defaultNumber,
      });
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      pinCode: "",
      userType: "",
      mobileNumber: "",
      errors: {},
      warning: {},
      loading: false,
      isProfileLoaded: false,
      showProfileUpdate: false,
      failedAttemps: 1,
      hashCode: "",
      resendCodePopUp: false,
      detailsLoaded: false,
      mobileNumForAuctions: "",
      lineEmailStatus: "",
      remainingAttempts: 0,
      locktime: 0,
      minutes: 0,
      seconds: 0,
    };
    let errorsInitial = {};
    if (window.isInValidFacebookLogin === "YES") {
      errorsInitial["customError"] = "invalid_facebook_account";
      this.state.errors = errorsInitial;
    }
  }

  handleUserChange = (evt) => {
    this.setState({
      username: evt.target.value,
    });
  };

  handlePassChange = (evt) => {
    this.setState({
      password: evt.target.value,
    });
  };

  handlePinChange = (evt) => {
    const re = /^[0-9\b]+$/;
    if (evt.target.value === "" || re.test(evt.target.value)) {
      this.setState({
        pinCode: evt.target.value,
      });
    }
  };

  getUserProfileDetails = async () => {
    if (!this.state.detailsLoaded) {
      this.setState({
        loading: true,
        detailsLoaded: true,
      });
      const result = await profileEnquiry();
      const presult = result.data.data;
      const [context, dispatch] = this.context;
      dispatch({
        type: 'SET_PROFILE_ENQUIRY_RESULT_AND_USERTYPE',
        payload: { 
          userType: this.state.userType,
          mobileNum: presult.contactInfo?.mobileNumber.replace("+", ""),
          profileEnquiryResult: presult 
        }
      })

      if (presult.auctionProfile.updated === "Y") {
        localStorage.setItem('contactNumber', presult.contactInfo.mobileNumber);
        $("#formLogin").attr("action", window.loginURL).submit();
      }
      else {
        this.setState({
          showProfileUpdate: true,
          isProfileLoaded: true,
          loading: false,
        });
      }
    }
  }

  async loginUser(userName, password) {
    const user = await checkUser(userName, password);
    const encryptedUserName = encrypt(userName);

    let errors = {};
    if (user.error) {
      this.setState({ error: user.error });
    } else {
      if (user.data.status == 200) {
        document.cookie = `nm=${encryptedUserName}; path=/`;
        localStorage.setItem("loginType", "UNL");
        if (user.data.message === "CHOOSE_MASTER_LINE_SELECTION") {
          //console.log("Show Contact Center");
          this.props.setShowCC(true);
        }
        if (user.data.message === "RESET_PASSWORD") {
          //console.log("ResetPassword");
          this.props.setShowResetPassword(true, userName);
        }
        if (
          user.data.response != null &&
          user.data.response.userType === "NON_MOBILY_USER"
        ) {
          this.setState({
            errors: errors,
            loading: false,
          });
          const accountType = getParameter("account_type");
          if (accountType && accountType === "auctions") {
            const cookies = new Cookies();
            const profileUpdate = "profileUpdate";
            cookies.set(profileUpdate, "N", { path: "/wps/portal/web" });
          }
          $("#formLogin").attr("action", window.loginURL).submit();

        } else if (
          user.data.response != null &&
          (user.data.response.userType === "CORPARATE" ||
            user.data.response.userType === "CONSUMER")
        ) {
          this.setState({
            userType: user.data.response.userType,
            mobileNumber: user.data.response.mobile,
            errors: errors,
            loading: false,
          });
        } else {
          let errors = {};
          errors["customError"] = "error";
          this.setState({
            errors: errors,
            loading: false,
          });
        }

        //Invalid User Credintail
      } else {
        this.accountLockoutErrorHandler(user);

        // counter to show captcha after 3 failed attempts
        if (this.state.failedAttemps === 3) {
          this.recaptcha.execute();
          this.state.failedAttemps = 1;
          this.setState({
            loading: false,
          });
        } else {
          //console.log("no recaptcha");
          // this.recaptcha.reset();
          this.setState({
            loading: false,
            failedAttemps: ++this.state.failedAttemps,
          });
        }
      }
    }
  }

  accountLockoutErrorHandler = (user) => {
    let errors = {};
    const { t } = this.props;
    console.log(user);
    if (user.data.status === "400") {
      errors["customError"] = "invalid_credintial";
    }

    if (user.data.status === "434") {
      const attempts = user.data.response.remainingAttempts;
      const attemptsMsg = window.lang === 'en' ? `You have only ${attempts} password attempts left.` : `المحاولات المتبقية لديك ${attempts}`
    
      this.setState({
        locktime: user.data.response.locktime,
        remainingAttempts: attempts
      });

      errors["customError"] = `${attemptsMsg} ${t('acc_caution_msg')}${t('call_for_help')}`;
    }

    if (user.data.status === "435") {
      this.secondsConvertor(user.data.response.locktime);
      errors["customError"] = `${t('max_attempts_reached')} ${t('securing_account')}`;
      this.setState({
        locktime: user.data.response.locktime,
        remainingAttempts: user.data.response.remainingAttempts
      });
    }

    if (user.data.status === "436") {
      clearInterval(this.myInterval);
      this.secondsConvertor(user.data.response.locktime);
      errors["customError"] = `${t('securing_account')}`;
      this.setState({
        locktime: user.data.response.locktime,
        remainingAttempts: user.data.response.remainingAttempts
      });
    }

    this.setState({
      errors: errors,
    });
  };

  secondsConvertor(timeInSec) {
    let mins = Math.floor(timeInSec / 60);
    let secs = timeInSec % 60;
    mins = mins < 10 ? `0${mins}` : mins;
    secs = secs < 10 ? `0${secs}` : secs;

    this.setState({
      minutes: parseInt(mins),
      seconds: parseInt(secs),
    });

    this.myInterval = setInterval(() => this.handleTicker(), 1000);
  }

  handleTicker = () => {
    const { seconds, minutes } = this.state;
    if (seconds > 0) {
      this.setState(({ seconds }) => ({
        seconds: seconds - 1,
      }));
    }
    if (seconds === 0) {
      if (minutes === 0) {
        clearInterval(this.myInterval);
      } else {
        this.setState(({ minutes }) => ({
          minutes: minutes - 1,
          seconds: 59,
        }));
      }
    }
  };

  handaleSubmit = async (e) => {
    e.preventDefault();
    if (this.validateForm() && !this.state.userType) {
      this.setState({
        loading: true,
        locktime: 0,
      });
      this.loginUser(this.state.username, this.state.password);
    } else if (this.state.userType === "NON_MOBILY_USER") {
      $("#formLogin").attr("action", window.loginURL).submit();
    } else if (this.validateForm()) {
      this.handaleValidateOTP();
    }
  };

  handaleValidateOTP = async () => {
    if (this.validateForm()) {
      this.setState({
        loading: true,
      });

      const result = await validateOTP(
        this.state.pinCode,
        this.state.mobileNumber
      );

      if (result.data.message === "VALID_OTP") {
        const accountType = getParameter("account_type");
        if (accountType && accountType === "auctions") {
          const cookies = new Cookies();
          const profileUpdate = "profileUpdate";
          cookies.set(profileUpdate, "N", { path: "/wps/portal/web" });
        }
        $("#formLogin").attr("action", window.loginURL).submit();
      } else if (result.data.message === "INVALID_OTP") {
        let errors = {};
        errors["customError"] = "pin_Code_incorrect";

        this.setState({
          errors: errors,
          loading: false,
        });
      } else if (result.data.message === "MAX_NUMBER_ALLOW") {
        let errors = {};
        errors["customError"] = "MAX_NUMBER_ALLOW";

        this.setState({
          errors: errors,
          loading: false,
        });
        this.reset();
      } else if (result.data.message === "EXPIRED") {
        let errors = {};
        errors["customError"] = "EXPIRED";

        this.setState({
          errors: errors,
          loading: false,
        });
        this.reset();
      } else {
        let errors = {};
        errors["customError"] = "EXPIRED";
        this.setState({
          errors: errors,
          loading: false,
        });
        this.reset();
      }
    }
  };

  reset = () => {
    this.setState({
      username: "",
      password: "",
      pinCode: "",
      userType: "",
      mobileNumber: "",
      loading: false,
    });
  };

  onFocus = (event) => {
    event.target.setAttribute("autocomplete", "off");
  };

  resendSMS = async () => {
    reSendSMS(this.state.mobileNumber, window.lang);
  };

  handleOk = (e) => {
    this.setState({
      laoding: false,
      resendCodePopUp: false,
    });
    //console.log("Inside handle ok. visibleflag: " + this.state.resendCodePopUp);
  }

  handleCancel = (e) => {
    this.setState({
      loading: false,
      resendCodePopUp: false,
    });
    //console.log("Inside handleCancel. visibleflag: " + this.state.resendCodePopUp);
  }

  validateForm() {
    let errors = {};
    let formIsValid = true;

    if (!this.state.username) {
      formIsValid = false;
      errors["username"] = "username_required";
    }

    const userNameRegular = /^[0-9A-Za-z][A-Za-z0-9_\.-]*$/;
    if (this.state.username && !userNameRegular.test(this.state.username)) {
      formIsValid = false;
      errors["username"] = "username_format";
    }

    if (!this.state.password) {
      formIsValid = false;
      errors["password"] = "password_required";
    }

    if (!this.state.pinCode && this.state.userType) {
      formIsValid = false;
      errors["pinCode"] = "pin_code_required";
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  render() {
    const { t } = this.props;
    const { loading, minutes, seconds, locktime } = this.state;
    const accountType = getParameter("account_type");
    const pu = getParameter("pu");

    if ("N" === pu && accountType === "auctions" && !this.state.isProfileLoaded) {
      const cookies = new Cookies();
      const profileUpdate = "profileUpdate";
      cookies.remove(profileUpdate);
      this.getUserProfileDetails();
    }

    return (
      <div>
        <Recaptcha
          ref={(ref) => (this.recaptcha = ref)}
          sitekey={window.INVISIBLE_CAPTCHA_V2_SITE_KEY}
          locale={window.lang}
          onResolved={() => {
            this.recaptcha.reset();
          }}
        />

        {/* Error alert */}
        {this.state.errors.customError ? (
          <div className="alert alert-danger" role="alert">
            <b>
              {t(this.state.errors.customError)}{" "}
              {locktime == 0 ? (
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
              ) : (
                <span>
                  : {minutes > 9 ? minutes : `0${minutes}`}:
                  {seconds > 9 ? seconds : `0${seconds}`}
                </span>
              )}
            </b>
          </div>
        ) : null}

        {/* Warning alert */}
        {this.state.userType &&
        !this.state.errors.customError &&
        !this.state.loading ? (
          <div className="alert alert-danger" role="alert">
            {t("warnning_alert_sms")}{" "}
            {this.state.mobileNumber.replace(/.(?=.{3})/g, "x")}.
          </div>
        ) : null}

        {/* Profile Update Screens */}
        {this.state.showProfileUpdate ? (
          <form id="profile-update-form" >
            <ProfileUpdate />
          </form>) : null
        }
        
        {!this.state.showProfileUpdate && "N" != getParameter("pu") ? (
          <form id="login-form" onSubmit={this.handaleSubmit}>
            
            {/* Username */}
            {!this.state.userType ? (
              <div
                id="login-form-div"
                className={
                  "form-group " +
                  (this.state.errors.username ? "not-valid" : "")
                }
              >
                <label
                  className="input-label"
                  style={{
                    visibility: this.state.username ? "visible" : "hidden",
                  }}
                >
                  {t("username")}
                </label>

                <input
                  id="login-username"
                  type="text"
                  className="form-control"
                  placeholder={t("username")}
                  value={this.state.username}
                  maxLength="50"
                  onChange={this.handleUserChange}
                  autocomplete="new-password"
                  onFocus={this.onFocus}
                />

                {/* use  border-danger class to make input border red  */}

                {/* red alert  */}
                {this.state.errors.username ? (
                  <div className="alert alert-danger" role="alert">
                    {t(this.state.errors.username)}{" "}
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                  </div>
                ) : (
                  <div className="empty-alert">&nbsp;</div>
                )}
                {/* red alert  */}
              </div>
            ) : null}
            
            {/* Password */}
            {!this.state.userType ? (
              <div
                className={
                  "form-group " +
                  (this.state.errors.password ? "not-valid" : "")
                }
              >
                <label
                  className="input-label"
                  style={{
                    visibility: this.state.password ? "visible" : "hidden",
                  }}
                >
                  {t("password")}
                </label>

                <input
                  type="password"
                  id="login-password"
                  className="form-control"
                  placeholder={t("password")}
                  value={this.state.password}
                  maxLength="50"
                  onChange={this.handlePassChange}
                  autocomplete="new-password"
                  onFocus={this.onFocus}
                />

                {/*use  border-danger class to make input border red  */}

                {/* red alert  */}

                {this.state.errors.password ? (
                  <div className="alert alert-danger" role="alert">
                    {t(this.state.errors.password)}{" "}
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                  </div>
                ) : (
                  <div className="empty-alert">&nbsp;</div>
                )}
                {/* red alert  */}
              </div>
            ) : null}
            
            {/* OTP Screen is shown to mobily users only */}
            {this.state.userType ? (
              <div
                className={
                  "form-group " + (this.state.errors.pinCode ? "not-valid" : "")
                }
              >
                <label
                  className="input-label"
                  style={{
                    visibility: this.state.pinCode ? "visible" : "hidden",
                  }}
                >
                  {t("pin_code")}
                </label>
                <input
                  type="text"
                  id="pincode"
                  className="form-control "
                  placeholder={t("pin_code")}
                  pattern="[0-9]*"
                  maxLength="4"
                  value={this.state.pinCode}
                  onChange={this.handlePinChange}
                />
                {/* red alert  */}

                {this.state.errors.pinCode ? (
                  <div className="alert alert-danger" role="alert">
                    {t(this.state.errors.pinCode)}{" "}
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                  </div>
                ) : (
                  <div className="empty-alert">&nbsp;</div>
                )}
                {/* red alert  */}
              </div>
            ) : null}
            
            {/* Forgot Password Link */}
            {!this.state.userType ? (
              <p className="forget_pass" id="forgotPassword">
                <a href={window.FORGOT_ACCOUNT_LINK}>{t("forget_password")}</a>
              </p>
            ) : null}
            
            {/* Checkbox */}
            {!this.state.userType ? (
              <div className="form-group ">
                <label className="checkboxcontainer keepme_loggedin">
                  {t("keep_login")}
                  <input type="checkbox" id="keepMe_LoggedIn" />
                  <span className="checkmark"></span>
                </label>
              </div>
            ) : null}
            
            {/* Privacy Policy Text */}
            <p class="headerdescription mt-4">
              {t("by_login_agree")}{" "}
              <a id="privacyPolicy" href={window.PRIVACY_BAR_LINK}>
                <u>{t("privacy_policy")}</u>
              </a>
            </p>
            
            {/* Login Button */}
            {!this.state.userType ? (
              <button
                id="login-btn"
                type="submit"
                className="btn min_outlin_btn active"
                // disabled
              >
                {t("login")}{" "}
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            ) : null}

            {/* OTP Submit Button is shown to mobily users only */}
            {this.state.userType ? (
              <button
                type="button"
                id="login-btn"
                onClick={this.handaleValidateOTP}
                className="btn min_outlin_btn active"
              >
                {t("login")}{" "}
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            ) : null}

            <br />
            {/* Register Button */}
            <a
              href={
                accountType == "business"
                  ? window.REGISTRATION_LINK.replace(/personal/g, "business") +
                    "?account_type=business"
                  : accountType == "auctions"
                  ? window.REGISTRATION_LINK + "?account_type=auctions"
                  : window.REGISTRATION_LINK + "?account_type=personal"
              }
            >
              <button
                id="registration"
                type="button"
                className="btn min_outlin_btn"
              >
                {t("signup")} {loading}
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            </a>

            {/* Facebook */}
            <a
              href={window.generateFacebookAuthURL}
              className="btn min_outlin_btn"
              style={{ display: "none" }}
            >
              <span>
                <i className="fab fa-facebook-f"></i>
                {t("face_book")}
              </span>
              <i className="fa fa-arrow-right"></i>
            </a>
          </form>
        ) : null}
        {loading ? <div className="loading">Loading&#8230;</div> : null}
      </div>
    );
  }
}
export default withTranslation()(Login);
